'use strict';

// 访问接口的总方法名称
const http_method = '/Data_All'  //润恒新能源
const http_downfile = '/DownLoadFile' 

// 访问接口的总方法口令
const http_token = 'rhkj'     //润恒新能源

export default {
  http_method,
  http_token,  
  http_downfile
}
